import { Equipment } from "./../../../modules/setup-equipment/setup-equipment.model";
import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  Output,
  EventEmitter,
} from "@angular/core";
import {
  EqualiserBar,
  EqualiserBarImages,
} from "../../../entities/setup/model";
import { ManageEquipmentService } from "../../../modules/manage-equipment/manage-equipment.service";
import { NotificationsService } from "angular2-notifications";
import { InterpretationService } from "../../../modules/interpretation/interpretation.service";
import { MatDialog } from "@angular/material/dialog";
import { ChangeComponentComponent } from "../../../modules/manage-equipment/components/change-component/change-component.component";
import { PopupEndPoint } from "../../../modules/inspection/models/create-inspection.model";
import { ViewPhotoComponentComponent } from "../add-photo/view-photo/view-photo-component";
import { ModuleType } from "../../enums/allEnums";
import { ComponentImageHistoryComponent } from "../component-image-history/component-image-history.component";
import { ModelBaseObservations } from '../../../modules/setup-models/setup-models.model';

@Component({
  selector: "app-equaliser-bar",
  templateUrl: "./equaliser-bar-component.html",
  styleUrls: ["./equaliser-bar-component.scss"],
})
export class EqualiserBarComponentComponent implements OnInit {
  @Input() EquipmentId: number;
  @Input() InspectionId: number | null;
  @Input() IsInterpSaveApi: boolean = false;
  @Input() IsEdit: boolean = false;
  @Input() IsInspection: boolean = false;
  @Input() IsCondition: boolean = true;
  @Input() ObservationInfo: ModelBaseObservations[] = [];
  @Input() MeasurementUnit: string;
  @Output() equaliserBarChanged = new EventEmitter<EqualiserBar>();
  @Output() commentChanged = new EventEmitter<any>();
  equaliserBar: EqualiserBar = new EqualiserBar();
  showComments: boolean = false;
  showHistoryImages: boolean = false;
  FamilyImage_Equaliser: boolean = false;
  SystemImages: any[] = [];
  eqBarComment: string;
  comingFrom: PopupEndPoint;
  loadData: boolean = false;
  imageHistoryAvailable: boolean = false;
  moduleType = ModuleType.UC;
  module!: ModuleType;
  borderClassCenter: string;
  borderClassOLeft: string;
  borderClassORight: string;
  SystemId: number;
  InspDetailId: number;
  constructor(
    private _equipmentService: ManageEquipmentService,
    private _notify: NotificationsService,
    private _interp: InterpretationService,
    private _dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.getEqualiserData();
    console.log('this this', this.IsCondition);
    if (this.InspectionId != null) {
      if (this.IsInterpSaveApi) {
        this.comingFrom = PopupEndPoint.InterpretationComponent;
      } else if (this.InspectionId === 0) {
        this.comingFrom = PopupEndPoint.AddNewInspectionComponent;
      } else {
        this.comingFrom = PopupEndPoint.CreateEditInspectionComponent;
      }
    }
  }

  emitEqualiserBar(): void {
    this.equaliserBarChanged.emit({ ...this.equaliserBar });
  }

  onCommentUpdated(result: any) {
    this.equaliserBar.EqBarComment = result.comment;
    if (this.comingFrom != PopupEndPoint.InterpretationComponent)
      this.emitEqualiserBar();
    else this.getEqualiserData();
  }

  onEqualiserBarChanged(column: string): void {
    if (!this.IsInterpSaveApi) {
      this.emitEqualiserBar();
      return;
    }
    // if (this.equaliserBar.InspectionId == null) {
    //   this._equipmentService
    //     .updateEqualiserBarCondiiton(this.equaliserBar)
    //     .subscribe({
    //       next: (success) => {
    //         if (success) {
    //           this._notify.success(
    //             `Equaliser Bar ${column} updated successfully.`,
    //           );
    //         } else {
    //           this._notify.error(`Failed to update Equaliser Bar ${column}.`);
    //         }
    //       },
    //       error: () => {
    //         this._notify.error(
    //           "An error occurred while updating Equaliser Bar.",
    //         );
    //       },
    //     });
    //   }
    // } else {
    //   this._interp.updateEqualiserBar(this.equaliserBar).subscribe({
    //     next: (success: boolean) => {
    //       if (success) {
    //         this._notify.success(
    //           `Equaliser Bar ${column} updated Successfully.`,
    //         );
    //       } else {
    //         this._notify.error(`Failed to update Equaliser Bar ${column}.`);
    //       }
    //     },
    //     error: () => {
    //       this._notify.error("An error occurred while updating Equaliser Bar.");
    //     },
    //   });
    // }
  }

  openEditComponentPopup() {
    const viewModalRef = this._dialog.open(ChangeComponentComponent, {
      width: "500px",
      data: {
        eQunitId: this.equaliserBar.Id,
        make: this.equaliserBar.BrandId,
        budgetLife: this.equaliserBar.BudgetLife,
        equipmentId: this.equaliserBar.EquipmentId,
        isEqualiserBar: true,
        currentEqBar: this.equaliserBar.ToeOut,
      },
    });
    viewModalRef.afterClosed().subscribe((result) => {
      console.log("viewModalRef.afterClosed() result:", result);
      if (result) {
        this.getEqualiserData();
      }
    });
  }

  getEqualiserData(): void {
    this._equipmentService
      .getEqualiserBarData(this.EquipmentId, this.InspectionId)
      .subscribe({
        next: (res) => {
          this.equaliserBar = res;
          this.InspDetailId = this.equaliserBar.InspDetailId;
          this.SystemId = this.equaliserBar.SystemId;
          this.imageHistoryAvailable =
            this.equaliserBar.EqBarImages?.length > 0 ? true : false;
          this.borderClassCenter = this.GetBorderColour(
            this.equaliserBar.MeasurementCenter,
            "MC",
          );
          this.borderClassOLeft = this.GetBorderColour(
            this.equaliserBar.MeasurementOuterLeft,
            "MOLR",
          );
          this.borderClassORight = this.GetBorderColour(
            this.equaliserBar.MeasurementOuterRight,
            "MOLR",
          );
          this.loadData = true;
          console.log(this.equaliserBar);

          this.emitEqualiserBar();
        },
        error: (err) => {
          console.error("Error loading Equaliser Bar data", err);
        },
      });
  }

  GetBorderColour(value: number, mType: string) {
    if (value == null) {
      return "";
    }
    if (mType == "MC") {
        let info = this.ObservationInfo.find(
          (x) => x.Title == "Equaliser Bar Centre",
        );
        if (info != null && value != null) {
          if (value < info.Max) return "pass";
          else return "fail";
        } else if (info == null && value != null) return "notmeasure";
        else return "";
      
    } else if (mType == "MOLR") {
      let info = this.ObservationInfo.find(
        (x) => x.Title == "Equaliser Bar Outer Left & Right",
      );
      if (info != null && value != null) {
        if (value < info.Max) return "pass";
        else return "fail";
      } else if (info == null && value != null) return "notmeasure";
      else return "";
    }  else {
      return "";
    }
  }

  updateComponentMeasurement(type: 'MC' | 'MOL' | 'MOR', value: number): void {
    switch (type) {
      case 'MC':
        this.borderClassCenter = this.GetBorderColour(value, 'MC');
        this.onEqualiserBarChanged('Center');
      break;
      case 'MOL':
        this.borderClassOLeft = this.GetBorderColour(value, 'MOLR');
        this.onEqualiserBarChanged('Outer Left');
      break;
      case 'MOR':
        this.borderClassORight = this.GetBorderColour(value, 'MOLR');
        this.onEqualiserBarChanged('Outer Right');
      break;
    }
    //this.emitEqualiserBar();
  }

  viewComponentPhoto(img: EqualiserBarImages) {
    const viewPhotoModalRef = this._dialog.open(ViewPhotoComponentComponent, {
      width: "800px",
      data: {
        Data: img,
        comingFrom: this.comingFrom,
        inspectionId: this.InspectionId,
      },
    });
    viewPhotoModalRef.afterClosed().subscribe((result) => {
      if (result) {
        if (this.comingFrom == PopupEndPoint.InterpretationComponent) {
          this.getEqualiserData();
        } else {
          switch (result.action) {
            case "delete":
              this.equaliserBar.EqBarImages =
                this.equaliserBar.EqBarImages.filter((x) => x !== result.image);
              this.equaliserBar.EqBarImages.forEach((x) => {
                x.ImagePath = this.removeS3Url(x.ImagePath);
              });
              this.emitEqualiserBar();
              break;

            case "update":
              img.IsDeleted = false;
              img.ImagePath = result.image.ImagePath;
              img.ImageUrl = result.image.ImageUrl;
              break;
          }
          this.emitEqualiserBar();
        }
      }
    });
  }

  private removeS3Url(path: string): string {
    if (!path) {
      return path;
    }
    const index = path.indexOf(".com/");
    if (index > -1) {
      return path.substring(index + 5);
    }
    return path;
  }

  loadSystemImages(image: EqualiserBarImages) {
    if (this.comingFrom == PopupEndPoint.InterpretationComponent)
      this.getEqualiserData();
    else {
      if (!this.equaliserBar.EqBarImages) {
        this.equaliserBar.EqBarImages = [];
      }
      this.equaliserBar.EqBarImages = [...this.equaliserBar.EqBarImages,image];
      this.emitEqualiserBar();
    }
  }
  sanitize(image: EqualiserBarImages): string {
    if (image?.ImagePath?.startsWith("https://")) {
      return image.ImagePath;
    }
    if ((image as any)?.ImageUrl?.startsWith("https://")) {
      return (image as any).ImageUrl;
    }
    return "";
  }
  openPhoto() {
    this._dialog.open(ComponentImageHistoryComponent, {
      width: "80%",
      height: "95%",
      data: {
        module: this.moduleType,
        equipmentId: this.EquipmentId,
        inspectionId: this.InspectionId,
        type: 4,
        side: 0
      },
    });
  }
}
